export default "__VITE_ASSET__8290dfc0__"